import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const EntryFragment = gql`
  fragment EntryFragment on Entry {
    id
    entryId
    date
    meal
    food
    serving
    calories
    protein
    carbs
    fat
    createdAt
    updatedAt
  }
`;

export const get = gql`
  query EntryGet($entryId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        entries {
          id
          get(entryId: $entryId) {
            ...EntryFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${EntryFragment}
`;

// Every day from `from` to `to`, each with its totals and its entries. The day
// screen asks for a week ending on the day it shows: the strip across the top
// is the six before it, and the list below is the last one.
export const days = gql`
  query EntryDays($input: EntryDaysInput!) {
    viewer {
      id
      account {
        id
        entries {
          id
          days(input: $input) {
            id
            date
            totals {
              calories
              protein
              carbs
              fat
              count
            }
            entries {
              ...EntryFragment
            }
          }
        }
      }
    }
  }
  ${EntryFragment}
`;

export const search = gql`
  query EntrySearch($input: SearchInput!) {
    viewer {
      id
      account {
        id
        entries {
          id
          search(input: $input) {
            id
            last
            items {
              ...EntryFragment
            }
          }
        }
      }
    }
  }
  ${EntryFragment}
`;

export const create = gql`
  mutation EntryNew($input: EntryInputCreate!) {
    viewer {
      account {
        entries {
          create(input: $input) {
            ...EntryFragment
          }
        }
      }
    }
  }
  ${EntryFragment}
`;

export const edit = gql`
  mutation EntryEdit($entryId: String!, $input: EntryInputUpdate!) {
    viewer {
      account {
        entries {
          get(entryId: $entryId) {
            update(input: $input) {
              ...EntryFragment
            }
          }
        }
      }
    }
  }
  ${EntryFragment}
`;

export const remove = gql`
  mutation EntryRemove($entryId: String!) {
    viewer {
      account {
        entries {
          get(entryId: $entryId) {
            remove
          }
        }
      }
    }
  }
`;

// Evict every cached entry under this service's entry namespace.
//
// The literal `entries/queries` is what EntryQueries.id resolves to on the
// server, and the two are pinned against each other in
// api/code/test/schema.test.js — if they drift, a create succeeds and the day
// screen stays stale with no error anywhere.
export const update = () => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`entries/queries`)) {
      cache.data.delete(key);
    }
  });
};
